import script from "./PaymentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentTab.vue?vue&type=script&setup=true&lang=js"

import "./PaymentTab.vue?vue&type=style&index=0&id=0acf1ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acf1ef4"]])

export default __exports__